import { FormProvider, useForm } from "react-hook-form";
import { TQuizForm } from "types/quiz";
import { useLearnStore } from "../store";
import * as Dialog from '@radix-ui/react-dialog';
import { QuizForm } from "./QuizForm";
import clsx from "clsx";
import { Button } from "components/Button";
import { learnService } from "../service";

export const QuizModal = () => {
  const { isQuizModalOpen, setQuizModalOpen } = useLearnStore();

  const form = useForm<TQuizForm>({
    values: {
      description: '',
      name: '',
      questions: [],
    },
    mode: 'all',
  });

  const isEdit = false;
  const handleClose = () => {
    setQuizModalOpen(false);
    form.reset();
  }

  const handleSubmit = async (data: TQuizForm) => {
    const isCreated = await learnService.createQuiz(data);

    if (isCreated) {
      handleClose();
    }
  };

  return (
    <Dialog.Root
      open={isQuizModalOpen}
      onOpenChange={handleClose}
      modal={false} 
    >
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-[#000] bg-opacity-[0.3] backdrop-blur-[2px]" />
        <Dialog.Content
          className={clsx(
            'fixed left-[50%] top-[50%] max-h-[85vh] w-[90vw] max-w-[800px]',
            'translate-x-[-50%] translate-y-[-50%] rounded-[6px] p-[25px]',
            'focus:outline-none bg-[#171717]',
            'flex flex-col'
          )}
          onInteractOutside={(e) => {
            e.preventDefault();
          }}
        >
          <Dialog.Title className="mb-8 text-xl font-medium">
            {isEdit ? 'Edit' : 'Create'} quiz
          </Dialog.Title>

          <form onSubmit={form.handleSubmit(handleSubmit)} className="flex flex-col gap-4 grow overflow-y-auto w-full">
            <FormProvider {...form}>
              <QuizForm />
            </FormProvider>

            <Button
              type="submit"
              extraClass="mt-8 mx-auto"
            >
              {form.formState.isSubmitting ? 'Saving...' : 'Save Changes'}
            </Button>
          </form>

          <Dialog.Close asChild>
            <button
              type="button"
              className="text-violet11 hover:bg-violet4 absolute right-[10px] top-[10px] h-[25px] w-[25px] items-center justify-center rounded-full focus:outline-none"
              aria-label="Close"
            >
              x
            </button>
          </Dialog.Close>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
